import { isPlatformBrowser } from '@angular/common'
import { Inject, Injectable, PLATFORM_ID } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class ViewportService {
  private isMobile = false

  constructor(@Inject(PLATFORM_ID) private platformId: object) {
    if (isPlatformBrowser(this.platformId)) {
      this.checkViewport()
      window.addEventListener('resize', () => this.checkViewport())
    }
  }

  private checkViewport(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = window.innerWidth < 844
    }
  }

  isMobileView(): boolean {
    return this.isMobile
  }
}
